export default __webpack_public_path__ + "static/media/search_icon.8d8c17e5.svg";